import {createSlice} from '@reduxjs/toolkit';

export const portDataSlice = createSlice({
    name: "portData",
    initialState: { value: {
        port: -1
    } },
    reducers: {
        portData: (state, action) => {
            state.value = action.payload
        },
    }
});

export const { portData } = portDataSlice.actions;

export default portDataSlice.reducer;